module.exports = __webpack_public_path__ + "static/media/cq_calendario.b36e1fa3.svg";